<template>
  <div >
    <div id="main-view">
      <dv-full-screen-container>
        <div id="main-top">
          <div class="mainHeader-left-decoration">
            <dv-decoration-8/>
            <div class="mainHeader-left">
              <el-select @change="changeProduct($event)" filterable v-model="deviceDefault">
                <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in deviceBoards">
                  <span :class="item.state === 'red' ? 'red-circle' : 'green-circle'"></span>
                  {{ item.name }}
                </el-option>
              </el-select>
            </div>
          </div>
          <dv-decoration-5 class="mainHeader-center-decoration"/>
          <!--        <dv-decoration-8 :reverse="true" class="header-right-decoration"/>-->
          <div class="mainHeader-right-decoration">
            <div class="mainHeader-left" :style="setDisplay()">
              <div class="mainHeader-weather-left">
                <p ><img :src="srcWeather"></p>
                <p>{{weatherAddress}}</p>
              </div>
              <div class="mainHeader-weather-right">
                <p>{{nowTime}}&emsp;{{type}}</p>
                <div>
                  <p>{{$t('wendu')}}： {{lowTemp}}&emsp;~&emsp;{{highTemp}}</p>
                  <p>{{$t('fengxiang')}}：{{windDirection}}&emsp;{{$t('fengli')}}：{{windPower}}</p>
                </div>
              </div>
            </div>
            <dv-decoration-8 :reverse="true"/>
            <div class="mainHeader-right">
              <el-button @click="logout" style="color: #51b9fb;font-size: 14px">{{$t("logout")}}</el-button>
              <div class="mainHeader-button">{{email}}</div>
            </div>
          </div>
          <div class="main-center-title">{{$t("cloudPlatform")}}</div>
        </div>
        <div class="main-content">
          <div class="mainContent-left">
            <div class="mainContent-left-top">
              <device-count ref="deviceCount"/>
            </div>
            <div class="mainContent-left-bottom">
              <device-warn @callBackInfo="getThreshold" ref="deviceWarn"/>
            </div>
          </div>
          <div class="mainContent-right">
            <div class="mainContent-right-top">
              <device-data @callBackInfo="selectParam" :thresholdInfo="thresholdArray" ref="deviceData"/>
            </div>
            <div class="mainContent-right-bottom">
              <device-history :partInfo="telemetryKey" ref="deviceHistory"/>
            </div>
          </div>

        </div>
      </dv-full-screen-container>
    </div>

  </div>
</template>

<script>
  import deviceCount from './DeviceCount'
  import deviceWarn from './DeviceWarn'
  import deviceData from './DeviceData'
  import deviceHistory from './DeviceHistory'
  import router from "../router/index"
  import moment from "moment";
  import axios from "axios";
  import {
    getAttributesServer,
    getAttributesShared,
    getCredentials,
    getCustomerDevice, getDeviceKey,
    getDevicesInfo, getDeviceValue
  } from "../untils/api/home";
  import {userLogin} from "../untils/api/login";
  export default {
    name: 'HomeNew',
    components: {
      deviceCount,
      deviceWarn,
      deviceData,
      deviceHistory
    },
    data() {
      return {
        deviceDefault: '',
        deviceBoards: [],
        email: '',
        deviceId: '',
        latestTelemetryStr: '',
        telemetryKey: [],
        thresholdArray: [],
        telemetryResponse: {},
        time: null,
        tokenTime: null,
        type: '',
        srcWeather: require('./img/wether1.png'),
        weatherAddress: '',
        weatherCode: '',
        nowTime:'',
        highTemp: '',
        lowTemp: '',
        windDirection: '',
        windPower: '',

      }
    },

    mounted() {
      //获取用户等级
      let authority = this.$route.params.authority === undefined ? this.$commonFun.deciphering(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.deciphering(localStorage.getItem('customerId')) : this.$route.params.customerId;
      //获取用户名
      this.email = this.$route.params.email === undefined ? this.$commonFun.deciphering(localStorage.getItem('email')): this.$route.params.email;

      if (authority === 'TENANT_ADMIN') {//用户为租户管理员
       getDevicesInfo().then(response => {
         this.getDeviceBoardList(response, authority);
       }).catch(error => {
         console.log("error", error)
       })
      } else { //用户为租户
        getCustomerDevice(customerId).then(response => {
          this.getDeviceBoardList(response, authority);
        }).catch(error => {
          console.log("error", error)
        })
      }
    },

    beforeDestroy() {
      clearInterval(this.time);
      this.time = null;
      clearInterval(this.tokenTime);
      this.tokenTime = null;
    },

    methods: {
      getDeviceBoardList(response, authority) {
        if(authority === 'TENANT_ADMIN') {
          if (response.data.length === 0) return;
          for (let i = 0; i < response.data.length; i++) {
            let deviceOption = {};
            deviceOption.id = response.data[i].id.id;
            deviceOption.name = response.data[i].name;
            deviceOption.type = response.data[i].id.entityType;
            this.deviceBoards.push(deviceOption);
          }

          // //设置默认选中的设备
          this.deviceDefault = this.deviceBoards[0].id;

          if(localStorage.getItem('deviceName') !== null) {
            let deviceJson = this.$commonFun.deciphering(localStorage.getItem('deviceName'));
            for(let i = 0; i < this.deviceBoards.length; i++) {
              if(this.deviceBoards[i].name === deviceJson) {
                this.deviceDefault = this.deviceBoards[i].id;
                break;
              }
            }
          }

          this.getDeviceToken();
          this.getDashInfo();
          localStorage.setItem("upLowList",null);
        } else {
          if (response.data.length === 0) return;
          let promises = [];

          let count = response.data.length;
          let onLine = 0;

          for (let i = 0; i < response.data.length; i++) {
            let deviceOption = {
              id: response.data[i].id.id,
              name: response.data[i].name,
              type: response.data[i].id.entityType
            };

            let promise = getAttributesServer(deviceOption.type, deviceOption.id).then(response => {
              let lastConnect = response.find(attr => attr.key === 'lastConnectTime');
              let lastActivity = response.find(attr => attr.key === 'lastActivityTime');
              let time = lastConnect != undefined ? lastConnect.value : lastActivity.value;
              let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
              if(time < beforeTime) {
                deviceOption.state = 'red';
              } else {
                deviceOption.state = 'green';
                onLine++
              }

              return deviceOption
            });
            promises.push(promise);
          }

          Promise.all(promises).then(results => {
            this.deviceBoards = results;

            // //设置默认选中的设备
            this.deviceDefault = this.deviceBoards[0].id;

            if(localStorage.getItem('deviceName') !== null) {
              let deviceJson = this.$commonFun.deciphering(localStorage.getItem('deviceName'));
              for(let i = 0; i < this.deviceBoards.length; i++) {
                if(this.deviceBoards[i].name === deviceJson) {
                  this.deviceDefault = this.deviceBoards[i].id;
                  break;
                }
              }
            }
            this.$refs.deviceCount.getDeviceNumInfo(count, onLine);
            this.getDeviceToken();
            this.getDashInfo();
            localStorage.setItem("upLowList",null);
          })

        }
      },

      getDeviceToken(){
        this.tokenTime = window.setInterval(() => {
          setTimeout(() => {
            this.getWeatherInfo();
            //let paramJsom =  JSON.parse(localStorage.getItem('login'));
            let paramJson = JSON.parse(this.$commonFun.deciphering(localStorage.getItem('login')));
            userLogin(paramJson).then(response => {
              //localStorage.setItem('token', response.token);
              localStorage.setItem('token', this.$commonFun.encryption(response.token));
            }).catch(error => {
            }).catch(error => {
              console.log("error", error);

            })
          }, 0)
        },1000 * 60 * 60 * 2);
      },


      changeProduct(event) {
        console.log("选中的设备：", this.deviceDefault);
        clearInterval(this.time);
        this.time = null;
        this.getDashInfo();
        localStorage.setItem("upLowList",null);
      },

      getDashInfo() {
        getCredentials(this.deviceDefault).then(response => {
          //根据设备id获取遥测数据key值
          this.getDeviceKeyInfo(response.deviceId);
          //获取天气预报地址
          this.getSharedData(response.deviceId);
          this.getServerData(response.deviceId);
        }).catch(error => {
          console.log("error", error)
        });

        this.time = window.setInterval(() => {
          setTimeout(() => {
            //访问api获取设备信息
            getCredentials(this.deviceDefault).then(response => {
              //根据设备id获取遥测数据key值
              this.getDeviceKeyInfo(response.deviceId);
            }).catch(error => {
              console.log("error", error)
            })
          }, 0)
        }, 1000 * 60);
      },

      getDeviceKeyInfo(deviceId) {
        getDeviceKey(deviceId.entityType, deviceId.id).then(response => {
          let deviceKey = '';
          let pattern = /^[A-Za-z0-9.-_-]+$/;
          //判断key是否存在
          response.length === 0 ? deviceKey = 'false' : deviceKey = '';
          //key 存在遍历取出 转成字符串
          for (let i = 0; i <= response.length - 1; i++) {
            if (pattern.test(response[i]) && !response[i].includes('ipv64g') && !response[i].includes('sig4g') && !response[i].includes('sigwifi')) {
              i === response.length - 1 ? deviceKey += response[i] : deviceKey += response[i] + ','
            }
          }

          //根据 设备id 遥测key 获取最新遥测value
          this.getLatestTelemetryData(deviceId, deviceKey);
          if (this.deviceId !== deviceId.id) {
            this.deviceId = deviceId.id;
            this.$refs.deviceHistory.getDeviceKeyList(deviceId, response);
          }
        }).catch(error => {
          console.log("error", error);
        })
      },

      getLatestTelemetryData(deviceId, deviceKey) {
        //key不存在清空数据
        if (deviceKey === 'false') {
          return;
        }

        getDeviceValue(deviceId.entityType, deviceId.id, deviceKey).then(response => {
          //console.log("LatestTelemetryData", response);
          if (JSON.stringify(response) !== this.latestTelemetryStr) {
            this.latestTelemetryStr = JSON.stringify(response);
            this.telemetryResponse = response;

            this.$refs.deviceData.getDeviceList(deviceId, response);
            this.$refs.deviceWarn.getDeviceWarn(deviceId, response)
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取天气预报地址
       * @param deviceId
       */
      getSharedData(deviceId) {
        this.weatherCode = '';
        this.weatherAddress = '';
        localStorage.setItem('levelRefer', 0);
        localStorage.setItem('snowRefer', 0);
        localStorage.setItem("emptyHRefer", 0);
        localStorage.setItem('noiseRefer', 0);
        localStorage.setItem("emptyHDRefer", 0);
        localStorage.setItem("cumFlow", null);
        getAttributesShared(deviceId.entityType, deviceId.id).then(response => {
          for(let i = 0; i < response.length; i++){
            if(response[i].key === "weather_address"){
              this.weatherCode = response[i].value;
              //获取天气预报信息
              this.getWeatherInfo()
            } else if(response[i].key === "level_refer") {
              localStorage.setItem('levelRefer', response[i].value);
            } else if(response[i].key === 'snow_refer') {
              localStorage.setItem('snowRefer', response[i].value);
            } else if(response[i].key == 'emptyH_refer') {
              localStorage.setItem("emptyHRefer", response[i].value);
            } else if(response[i].key == 'noise_refer') {
              localStorage.setItem('noiseRefer', response[i].value);
            } else if(response[i].key == 'emptyHD_refer') {
              localStorage.setItem('emptyHDRefer', response[i].value);
            } else if(response[i].key == 'cumFlow') {
              localStorage.setItem("cumFlow", response[i].value);
            }
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      getServerData(deviceId) {
        localStorage.setItem("fx", null);
        localStorage.setItem("HI", null);
        getAttributesServer(deviceId.entityType, deviceId.id).then(response => {
          for(let i = 0; i < response.length; i++){
            if(response[i].key == 'fx') {
              localStorage.setItem("fx", response[i].value);
              break;
            } else if(response[i].key == 'HI') {
              localStorage.setItem("HI", response[i].value)
              break;
            }
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      async getWeatherInfo() {
        if(this.weatherCode !== '') {
          let url = 'weather/city/' + this.weatherCode;
          return await axios({
            method: 'get',
            baseURL: process.env.Weather, // 修改这里
            url,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            timeout: 10000
          }).then(response => {
            this.nowTime = moment().format("YYYY-MM-DD");
            this.weatherAddress = response.cityInfo.city.toString().substring(0, response.cityInfo.city.length - 1);
            this.highTemp = response.data.forecast[0].high.toString().split(' ')[1];
            this.lowTemp = response.data.forecast[0].low.toString().split(' ')[1];
            this.windDirection = response.data.forecast[0].fx;
            this.windPower = response.data.forecast[0].fl;
            this.type = response.data.forecast[0].type;
          }).catch((error) => {
            this.weatherCode = '';
            console.log("error", error)
          })
        }
      },

      setDisplay() {
        if(this.weatherCode === ''){
          return {
            // color: color
            display: 'none'
          };
        }
      },

      selectParam(data) {
        this.telemetryKey = data;
      },

      getThreshold(data) {
        this.thresholdArray = data;
      },

      logout() {
        let local = localStorage.getItem('locale');
        localStorage.clear();
        clearInterval(this.tokenTime);
        this.tokenTime = null;
        clearInterval(this.time);
        this.time = null;
        localStorage.setItem('locale',local)
        router.replace('/logon')
      }
    }
  }
</script>

<style scoped lang="less">
  @import "less/HomeNew.less";
  @import "less/HeadNew.less";
</style>

<style>
  .red-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    margin-right: 5px;
  }

  .green-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomeNew.vue